module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-baby-FR.4fae87a.png";